module.exports = __webpack_public_path__ + "img/tree-05-f-trunk.51fabb80.png";